<!-- <div  class="blocks" [class.insideLoader]="type === 'inside'" >
    <div class="block orange"></div>
    <div class="block blue"></div>
  </div> -->
<div class="spinner">
  <div class="gifStyling">
    <img
      src="../../../assets/images/wetap_loader_latest.gif"
      style="height: 80px"
    />
  </div>
</div>
